export default {
  RESET_PAGE(state) {
    state.stats = []
    state.page = 1
    state.total = 10
  },
  SET_PAGE(state, payload) {
    state.page = payload
  },
  SET_ACTION_LOADING(state, payload) {
    state.actionLoading = payload
  },
  SET_SORTING(state, payload) {
    state.sorting = payload
  },
  SET_APP_DATA(state, data) {
    state.appData = data
  },
  SET_APPS_LIST(state, list) {
    state.appsList = list
  },
  SET_SWAP_STATS(state, data) {
    state.stats = [...state.stats, ...data.stats]
    state.total_partner_share = data.total_partner_share
    state.total = data.total
  },
  UPDATE_SWAP_STATS(state, stats) {
    if (state.stats) {
      state.stats = stats
    }
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
  },

  RESET_STORE(state) {
    state.appsList = []
    state.stats = []

    state.appData = null
    state.loading = false
    state.error = null
  },
}
